import { store } from '@/app'
import { initErrorReporting } from '@/features/error-reporting'
import { i18nInit } from '@/features/i18n'
import { PlanADesktopApp } from '@/shell/desktop'
import { PlanAMobileApp } from '@/shell/mobile'
import { FlagdWebProvider } from '@openfeature/flagd-web-provider'
import { OpenFeature } from '@openfeature/web-sdk'
import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { isDesktop } from './app/platform'
import { OpenFeatureClientProvider } from './features/feature-flags/FeatureFlagProvider'
import { Loading } from './features/loading'
import './index.css'

const App = isDesktop() ? PlanADesktopApp : PlanAMobileApp

// Start MSW in the browser when VITE_USE_MSW is set (e.g. for E2E tests)
if (import.meta.env.VITE_USE_MSW === 'true') {
  const { startMswWorker } = await import('@/msw-browser')
  await startMswWorker()
}

await i18nInit()
initErrorReporting()

const flagProvider = new FlagdWebProvider({
  host: import.meta.env.VITE_REACT_APP_FLAG_SERVER,
  port: 443,
  tls: true,
  maxRetries: 10,
  maxDelay: 30000,
})
OpenFeature.setProvider(flagProvider.metadata.name, flagProvider)

const persistor = persistStore(store)

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <OpenFeatureClientProvider provider={flagProvider}>
          <Suspense fallback={<Loading />}>
            <App />
          </Suspense>
        </OpenFeatureClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)
